import { useMutation } from "@tanstack/react-query";

import { type GeocodeQuery, geocodeAddress } from "@/adapters/geocoding";

// useGeocodeAddress wraps the Nominatim forward geocoder as an imperative
// mutation. Forms call it to center the map on a typed address when no
// coordinates exist yet; a null result (nothing found) is handled by the caller.
export function useGeocodeAddress() {
	return useMutation({
		mutationFn: (query: GeocodeQuery) => geocodeAddress(query),
	});
}
